import { Trans } from '@lingui/react'
import { type FC } from 'react'

interface InformationProps {
  hasDiscounts: boolean
  redPointsInCustomerAccount: number
}

const Information: FC<InformationProps> = ({
  hasDiscounts,
  redPointsInCustomerAccount,
}) => (
  <>
    {!hasDiscounts && redPointsInCustomerAccount < 1000 && (
      <div className="u-margin-large--bottom">
        <Trans id="cart.redPointsBox.notEnoughRedPoints" />
      </div>
    )}

    <div className="u-margin-large--bottom o-Cart__RedeemRedPoints__Information__current-amount">
      <strong className="o-Cart__RedeemRedPoints__Information__current-amount">
        <Trans id="cart.redPointsBox.currentAmount" />
      </strong>{' '}
      <span data-qa-id="redPoints-customer-current-amount">
        {redPointsInCustomerAccount}
      </span>
    </div>

    <span className="u-color--grey o-Cart__RedeemRedPoint__Information__info-text">
      <Trans id="cart.redPointsBox.infotext" />
    </span>
  </>
)

export default Information
